import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M7.5 3v2.5H10v2H7.5v2.499h-2v-2.5H3v-2h2.5V3h2z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.78 13.833l-3.116-3.115a.75.75 0 00-.53-.219h-.51a6.468 6.468 0 001.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 001.06 0l.884-.885a.753.753 0 00.003-1.062zm-4.281-7.334a5 5 0 11-10 0 5 5 0 0110 0z"
	})]
});
export default SvgZoomIn;
